import { render, staticRenderFns } from "./DemoComboboxClearable.vue?vue&type=template&id=7b554ae6&"
import script from "./DemoComboboxClearable.vue?vue&type=script&lang=js&"
export * from "./DemoComboboxClearable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
